'use client'
import Script from 'next/script';
import { useState } from "react";
import Skeleton from "react-loading-skeleton";

interface AppIconProps {
    className?: string
    style?: object
    hoveredClassName?: string
    iconClassName?: string
    type?: keyof typeof TYPES
    size?: keyof typeof SIZES
    title?: string
    onClick?: Function
}

// New types needs to be checked in FontAwesome kit to prevent useless font imports
// https://fontawesome.com/kits/dd60f349d9/settings
export const TYPES = {
    solid: 'fa-solid',
    regular: 'fa-regular',
    light: 'fa-light',
    sharp: 'fa-sharp',
    duotone: 'fa-duotone',
    brands: 'fa-brands',
    thin: 'fa-thin',
}

export const SIZES = {
    xxs: 'text-[0.5rem]',
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '4xl': 'text-4xl',
    '6xl': 'text-6xl',
    '8xl': 'text-8xl',
}

const ICON_LIB_SCRIPT_URL = 'https://kit.fontawesome.com/dd60f349d9.js'
const ICON_LIB_SCRIPT_ID = 'icon_lib_script_id'

const AppIcon = ({className, style, iconClassName, hoveredClassName = '', type = 'regular', size = 'md', title = undefined}: AppIconProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <>
            <Script
                src={ICON_LIB_SCRIPT_URL}
                strategy="lazyOnload"
                id={ICON_LIB_SCRIPT_ID}
            />
            <i
                className={`${SIZES[size]} inline-block text-center leading-[1em] ${className}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                {...(!title && {"aria-hidden": true})}
            >
                <i
                    className={`${TYPES[type]} h-full w-full ${iconClassName} ${isHovered && hoveredClassName}`}
                    style={style}
                    title={title}
                />
            </i>
        </>
    );
};

export const AppIconSkeleton = () => {
    return (
        <Skeleton
            containerClassName="h-5 w-5"
        />
    )
}

export default AppIcon;
